<template>
  <div class="comprehensive-form-container">
    <el-row :gutter="20">
      <el-col
        :lg="{ span: 12, offset: 6 }"
        :md="{ span: 20, offset: 2 }"
        :sm="{ span: 20, offset: 2 }"
        :xl="{ span: 12, offset: 6 }"
        :xs="24"
      >
        <el-form
          ref="form"
          class="demo-form"
          :label-position="labelPosition"
          label-width="100px"
          :model="form"
          :rules="rules"
        >
          <el-form-item label="安全提醒内容" prop="securityNotifyText">
            <el-input
              class="fix-width"
              v-model="form.securityNotifyText"
              placeholder="请输入安全提醒内容"
              type="textarea"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitForm('form')">
              保存
            </el-button>
            <el-button @click="resetForm('form')">重置</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getApp, setupConfig, getConfig } from '@/api/settings'
import { QNUploadURL, QNHost } from '@/config/net.config'
import { getUploadToken } from '@/api/app'
import storejs from 'store'
export default {
  name: 'SettingsBasic',
  data() {
    return {
      QNUploadURL,
      uploadToken: '',
      labelPosition: 'right',
      form: {
        securityNotifyText: '',
      },
      rules: {},
      isOpenAudio: false,
    }
  },
  async mounted() {
    this.getData()
    this.isOpenAudio = storejs.get('isOpenAudio') || false
    const token = await getUploadToken({})
    this.uploadToken = { token: token.token }
  },
  methods: {
    audioChange(val) {
      storejs.set('isOpenAudio', val)
    },
    
    async getData() {
      const config = await getConfig({ key: 'OA' })
      this.form.securityNotifyText = config.basic.securityNotifyText
    },
    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const config = await setupConfig({
            key: 'OA',
            securityNotifyText: this.form.securityNotifyText,
            
          })
          this.$message.success('保存基本信息配置成功')
        } else {
          this.$message.success('保存基本信息配置失败')
          return false
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
  },
}
</script>

<style lang="scss" scoped>
.fix-width {
  width: 500px;
}
::v-deep {
  .el-form-item__content {
    .el-rate {
      display: inline-block;
      font-size: 0;
      line-height: 1;
      vertical-align: middle;
    }

    .el-transfer__buttons {
      padding: 10px 10px 0 10px;
    }
  }
}
:deep(.el-upload) {
  border: 1px dashed #81878f;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.job-avatar {
  width: 335px;
  height: 252px;
  display: block;
}
</style>
